import { render, staticRenderFns } from "./ReviewClientDetails.vue?vue&type=template&id=30660ffa&"
import script from "./ReviewClientDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewClientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports